import { type SVGProps } from 'react'

export type IconName =
  | 'arrow-right'
  | 'box'
  | 'burger'
  | 'check'
  | 'check-circle'
  | 'chevron-down'
  | 'chevron-right'
  | 'clock'
  | 'close'
  | 'control'
  | 'percent'
  | 'phone'
  | 'pin'

type IconProps = {
  name: IconName
  size?: number
} & SVGProps<SVGSVGElement>

const ICON_PATHS: Record<IconName, React.ReactNode> = {
  'arrow-right': (
    <path d="M2.5 12h19m0 0-7-7m7 7-7 7" />
  ),
  box: (
    <>
      <path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z" />
      <path d="M3.5 7.5 12 12l8.5-4.5M12 12v9" />
    </>
  ),
  burger: (
    <path d="M4 6h16M4 12h16M4 18h16" />
  ),
  check: (
    <path d="m5 12 5 5 9-10" />
  ),
  'check-circle': (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m8.5 12 2.5 2.5 5-5" />
    </>
  ),
  'chevron-down': (
    <path d="m6 9 6 6 6-6" />
  ),
  'chevron-right': (
    <path
      d="M8.36133 6.62207C8.80895 7.02493 9.18037 7.35826 9.45703 7.65332C9.73911 7.95419 9.97546 8.26888 10.1094 8.65332C10.3132 9.23888 10.3133 9.87637 10.1094 10.4619C9.97543 10.8464 9.73916 11.161 9.45703 11.4619C9.18034 11.757 8.80901 12.0902 8.36133 12.4932L1.00391 19.1152L0 18L7.35742 11.3789C7.82464 10.9584 8.13926 10.6734 8.3623 10.4355C8.57991 10.2035 8.65734 10.0693 8.69238 9.96875C8.78511 9.70254 8.78507 9.41271 8.69238 9.14648C8.65736 9.04597 8.57984 8.91173 8.3623 8.67969C8.13928 8.44184 7.82456 8.15675 7.35742 7.73633L0 1.11523L1.00391 0L8.36133 6.62207Z"
      fill="currentColor"
      stroke="none"
      transform="translate(6.87 2.44)"
    />
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </>
  ),
  close: (
    <path d="M6 6l12 12M18 6 6 18" />
  ),
  control: (
    <>
      <path d="M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  percent: (
    <>
      <path d="M19 5 5 19" />
      <circle cx="7.5" cy="7.5" r="2.5" />
      <circle cx="16.5" cy="16.5" r="2.5" />
    </>
  ),
  phone: (
    <>
      <rect height="18" rx="3" width="12" x="6" y="3" />
      <path d="M11 17.5h2" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s7-5.1 7-11a7 7 0 1 0-14 0c0 5.9 7 11 7 11Z" />
      <rect height="4" rx="1" width="4" x="10" y="8" />
    </>
  ),
}

export const Icon = ({ name, size = 24, ...rest }: IconProps) => (
  <svg
    aria-hidden
    fill="none"
    height={size}
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.7}
    viewBox="0 0 24 24"
    width={size}
    {...rest}
  >
    {ICON_PATHS[name]}
  </svg>
)
